import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router";
import styles from "./styles";
import * as actions from "../../../actions/grillaPrincipal";
import { Container, Typography } from "@material-ui/core";
import Filtros from "../../GrillaPrincipal/Filtros/Filtros";
import TablaPresentaciones from "../../GrillaPrincipal/Tabla/Tabla";
import UploadFilesService from "../../../services/upload-files";

class GrillaPrincipal extends Component {
    buscarPresentaciones = () => {
        let nroPagTabla = parseInt(sessionStorage.getItem('nroPagTabla'));
        if (!nroPagTabla){
            nroPagTabla = 0;
        }
        
        const filtro = { ...this.props.filtro, page: nroPagTabla };
        this.props.getPresentaciones(filtro);
    };

    descargarGrilla = () => {
        const filtro = { ...this.props.filtro };
        delete filtro.page;
        delete filtro.size;

        UploadFilesService.descargarGrlla(filtro);
    };

    enviarNuevaPresentacion = () => {
        this.props.actualizarAtriutoGrilla({
            filtro: null,
            filtroActivo: false,
        });

        this.props.history.push("/nueva");
    };

    componentDidMount = () => { 
        this.props.getEstadosPresentaciones();

        let avisoMant = sessionStorage.getItem("AvisoMant");
        if (avisoMant != 'S'){
            this.props.mostarAviso();
        }
    };

    render() {
        const { classes } = this.props;
        return (
            <Container disableGutters={true} className={classes.container}>
                <Typography className={classes.tituloPrincipal}>
                    Consulta de presentaciones
                </Typography>
                <Filtros
                    estados={this.props.estados}
                    buscarHandler={this.buscarPresentaciones}
                    actualizarFiltros={this.props.setFiltroGrilla}
                />
                <TablaPresentaciones />

            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.grillaPrincipalReducer.filtro,
    estados: state.grillaPrincipalReducer.estados,
});

const actionCreators = {
    getPresentaciones: actions.getPresentaciones,
    setFiltroGrilla: actions.setFiltroGrilla,
    getEstadosPresentaciones: actions.getEstadosPresentaciones,
    actualizarAtriutoGrilla: actions.actualizarAtriutoGrilla,
    mostarAviso: actions.mostrarAviso,
    cerrarAviso: actions.cerrarAviso,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(withRouter(GrillaPrincipal)));
